import { HealthProfileFieldName } from '@auracare/shared'

import { apiClient } from '../config'

export type AppSettings = {
  model: string
  maxNumberOfOnboardingQuestions: number
  minNumberOfOnboardingQuestions: number
  requiredProfileFields: HealthProfileFieldName[]
  minProfileCompletionPercentage: number
  forwardReportsToEmails?: string
  labsTabEnabled?: boolean
  planButtonUrl?: string
  experienceCallEnabled?: boolean
  universalLoginLinksEnabled?: boolean
  funnelfoxStripeEnabled?: boolean
  funnelfoxPaypalEnabled?: boolean
  funnelfoxFfbillingEnabled?: boolean
  funnelStripeEnabled?: boolean
  funnelPaypalEnabled?: boolean
  missingNextPolicy?: string
  missingNextHoldHours?: number
  missingNextAfterHold?: string
  purchaseReceiptCancelUrl?: string | null
}

export type UpdateAppSettingsRequest = {
  model?: string
  maxNumberOfOnboardingQuestions?: number
  minNumberOfOnboardingQuestions?: number
  requiredProfileFields?: HealthProfileFieldName[]
  minProfileCompletionPercentage?: number
  forwardReportsToEmails?: string
  labsTabEnabled?: boolean
  planButtonUrl?: string
  experienceCallEnabled?: boolean
  universalLoginLinksEnabled?: boolean
  funnelfoxStripeEnabled?: boolean
  funnelfoxPaypalEnabled?: boolean
  funnelfoxFfbillingEnabled?: boolean
  funnelStripeEnabled?: boolean
  funnelPaypalEnabled?: boolean
  missingNextPolicy?: string
  missingNextHoldHours?: number
  missingNextAfterHold?: string
  purchaseReceiptCancelUrl?: string
}

export type OpenAITestResult = {
  success: boolean
  message: string
  model?: string
  responseTimeMs?: number
}

export type OpenAIBillingResult = {
  success: boolean
  message: string
  totalSpent?: number
  dailyCosts?: Array<{ date: string; amount: number }>
}

export const settingsService = {
  getAppSettings: async (): Promise<AppSettings> => {
    const response = await apiClient.get<AppSettings>('/admin/settings/app')
    return response.data
  },

  updateAppSettings: async (settings: UpdateAppSettingsRequest): Promise<AppSettings> => {
    const response = await apiClient.put<AppSettings>('/admin/settings/app', settings)
    return response.data
  },

  testOpenAIConnection: async (): Promise<OpenAITestResult> => {
    const response = await apiClient.post<OpenAITestResult>('/admin/settings/openai/test')
    return response.data
  },

  getOpenAIBilling: async (): Promise<OpenAIBillingResult> => {
    const response = await apiClient.get<OpenAIBillingResult>('/admin/settings/openai/billing')
    return response.data
  },
}
